import axios from "axios";
import React, { useEffect, useState } from "react";
import styles from "./styles.css";
import Select from "react-select";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Label,
} from "reactstrap";
import { URL_API } from "variable";
import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useHistory } from "react-router-dom";

import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { IMAGE_URL } from "variable";
import Modal from "react-bootstrap/Modal";

toast.configure();

function ArticleEdit() {
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
      [{ align: [] }],
      ["code-block"],
    ],
  };

  const formats = [
    "header",
    "font",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "align",
    "code-block",
  ];

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );
  const history = useHistory();
  const [title, setTitle] = useState();
  const [categoryList, setCategoryList] = useState([]);
  const [category, setCategory] = useState([]);
  const [description, setDescription] = useState("");
  const [description2, setDescription2] = useState("");
  const [description3, setDescription3] = useState("");
  const [tags, setTags] = useState([]);
  const [description_image, setDescriptionImage] = useState();
  const [image, setImage] = useState();
  const [tagList, setTagList] = useState([]);


  const [faqs, setFaqs] = useState([]);
  const [faqList, setFaqList] = useState([]);

  const id = useParams();
  const [article, setArticle] = useState([]);
  const [metaTitle, setMetaTitle] = useState();
  const [keyword, setKeyword] = useState();
  const [metaDescription, setMetaDescription] = useState("");
  //modal
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const handleClose = () => setShow(false);
  const handleClose2 = () => setShow2(false);

  //CATEGORY modal
  const [showCategory, setShowCategory] = useState(false);
  const handleCloseCategory = () => setShowCategory(false);

  //tag submit

  const [name, setName] = useState();
  const [tagFor, setFor] = useState();
  const [nameFaq, setNameFaq] = useState();
  const [tagForFaq, setForFaq] = useState();


  //CATEGORY submit
  const [categoryNameModel, setCategoryNameModel] = useState();
  const [categoryFor, setCategoryFor] = useState();

  useEffect(() => {
    getArticle();
    getTags();
    getFaqs();
    getCategory();

    let token = localStorage.getItem("token");
  }, [editorState]);

  const onTitleChange = (e) => {
    setTitle([e.target.value]);
  };
  const onDescChange = (e) => {
    setDescription([e.target.value]);
  };

  const onDescChange2 = (e) => {
    setDescription2([e.target.value]);
  };

  const onDescChange3 = (e) => {
    setDescription3([e.target.value]);
  };

  const onTagsChange = (tags) => {
    setTags(tags);
  };


  const onFaqsChange = (faqs) => {
    setFaqs(faqs);
  };


  const addTag = () => {
    setShow(true);
  };


  const addFaq = () => {
    setShow2(true);
  };

  const addCategory = () => {
    setShowCategory(true);
  };

  const onNameChange = (e) => {
    setName([e.target.value]);
  };

  const onCategoryNameChange = (e) => {
    setCategoryNameModel([e.target.value]);
  };

  const onTagForChange = (e) => {
    setFor([e.target.value]);
  };

  const onNameChangeFaq = (e) => {
    setNameFaq([e.target.value]);
  };

  const onTagForChangeFaq = (e) => {
    setForFaq([e.target.value]);
  };



  const onTagForCategoryChange = (e) => {
    setCategoryFor([e.target.value]);
  };

  const onImageChange = (event) => {
    if (!event.target.files[0]) {
      return false;
    } else {
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      setImage(files[0]);
    }
  };

  const onDescriptionImageChange = (event) => {
    if (!event.target.files[0]) {
      return false;
    } else {
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      setDescriptionImage(files[0]);
    }
  };

  const getArticle = () => {
    axios
      .get(URL_API + `auth/admin/articles/${id.id}/edit`)
      .then((response) => {
        if (response.data.status === 200) {
          setArticle(response.data.article);
          setTitle(response.data.article.title);
          setDescription(response.data.article.article_text);
          setDescription2(response.data.article.article_text2);
          setDescription3(response.data.article.article_text3);
          setMetaTitle(response?.data?.article?.meta_title);
          setKeyword(response?.data?.article?.keywords);
          setMetaDescription(response?.data?.article?.meta_description);
          setCategory(response?.data?.article?.category_id);

          const options = [];
          obj = {};
          for (var i = 0; i < response.data.article.tag.length; i++) {
            var obj = {};
            obj["value"] = response.data.article.tag[i].id;
            obj["label"] = response.data.article.tag[i].name;
            options.push(obj);
          }

          setTags(options);

          const optionss = [];
          obj = {};
          for (var i = 0; i < response?.data?.article?.faq.length; i++) {
            var obj = {};
            obj["value"] = response?.data?.article?.faq[i].id;
            obj["label"] = response?.data?.article?.faq[i].name;
            optionss.push(obj);
          }

          setFaqs(optionss);
        }
      });
  };

  const getTags = () => {
    axios
      .get(URL_API + "auth/customer/articles/create")
      .then((response) => {
        if (response.status == 200) {
          const options = [];
          obj = {};
          for (var i = 0; i < response?.data?.tags?.length; i++) {
            var obj = {};
            obj["value"] = response?.data?.tags[i]?.id;
            obj["label"] = response?.data?.tags[i]?.name;
            options.push(obj);
          }
          setTagList(options);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const getFaqs = () => {
    axios
      .get(URL_API + "auth/admin/get-faqs")
      .then((response) => {
        if (response.data?.status == 200) {
          const options = [];
          const categories = [];
          obj = {};
          for (var i = 0; i < response?.data?.tags?.length; i++) {
            if (response?.data?.tags[i]?.tag_for == "blogs") {
              var obj = {};
              obj["value"] = response?.data?.tags[i]?.id;
              obj["label"] = 'Question : ' + response?.data?.tags[i]?.name;
              options.push(obj);
            }
          }
          setFaqList(options);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onCategoryChange = (e) => {
    setCategory([e.target.value]);
  };

  const getCategory = () => {
    axios
      .get(URL_API + "auth/admin/category")
      .then((response) => {
        if (response.status == 200) {
          const options = [];
          obj = {};
          for (var i = 0; i < response.data.categories.length; i++) {
            if (response.data.categories[i].category_for == "blogs") {
              var obj = {};
              obj["id"] = response.data.categories[i].id;
              obj["title"] = response.data.categories[i].title;
              options.push(obj);
            }
          }
          setCategoryList(options);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onSubmit = (event) => {
    event.preventDefault();
    let formData = new FormData();
    formData.append("id", id.id);
    formData.append("title", title);
    formData.append("image", image);
    // formData.append("category_id", category);
    formData.append("description_image", description_image);
    formData.append("article_text", description);
    formData.append("article_text2", description2);
    formData.append("article_text3", description3);
    formData.append("tags", JSON.stringify(tags));
    formData.append("faqs", JSON.stringify(faqs));
    formData.append("meta_title", metaTitle);
    formData.append("keywords", '');
    formData.append("meta_description", metaDescription);

    axios
      .post(URL_API + "auth/admin/articles/update", formData)
      .then((response) => {
        if (response.status == 200) {
          history.push("/admin/articles");
          toast.success("Blog Updated Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          setTitle("");
          setImage("");
          setDescription("");
          setTags("");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onMetaTitleChange = (e) => {
    setMetaTitle([e.target.value]);
  };

  const onKeywordChange = (e) => {
    setKeyword([e.target.value]);
  };

  const onMetaDescriptionChange = (e) => {
    setMetaDescription([e.target.value]);
  };

  const onAddTagSubmit = (event) => {
    event.preventDefault();

    let formData = new FormData();
    formData.append("name", name);
    formData.append("tag_for", tagFor);

    axios
      .post(URL_API + "auth/admin/tags", formData)
      .then((response) => {
        if (response.status == 200) {
          // history.push("/admin/tags");/
          getTags();
          toast.success("Tag Added Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          setName("");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onAddCategorySubmit = (event) => {
    event.preventDefault();

    let formData = new FormData();
    formData.append("title", categoryNameModel);
    formData.append("category_for", categoryFor);

    axios
      .post(URL_API + "auth/admin/category", formData)
      .then((response) => {
        if (response.status == 200) {
          getCategory();
          // history.push("/admin/categories");
          toast.success("Category Added Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          setName("");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };





  const onSubmitFaq = (event) => {
    event.preventDefault();

    let formData = new FormData();
    formData.append("name", nameFaq);
    formData.append("tag_for", 'blogs');
    formData.append("answer", tagForFaq);

    axios
      .post(URL_API + "auth/admin/faqs", formData)
      .then((response) => {
        if (response.status == 200) {
          // history.push("/admin/faqs");
          getFaqs()
          setShow2(false)
          toast.success("Faq Added Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          setNameFaq("");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <>
      <div className="content">
        <form onSubmit={(e) => onSubmit(e)}>
          <div className={`container-fluid`}>
            <div className={styles.HeroiImgBlogForm}>
              <div className={styles.paddingTopBottomBlogForm}>
                <h3 className={styles.HeroiImgTextBlogForm}>Update Article</h3>
              </div>
            </div>
            <br />
            <div className="container">
              <div className={`form ${styles.blogPostForm}`}>
                <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    Title
                  </label>
                  <Input
                    name="title"
                    type="text"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    id="post-title"
                    required="required"
                    value={title}
                    onChange={(e) => onTitleChange(e)}
                  />
                </div>
                <br />
                <div className="form-group">
                  {" "}
                  <div
                    onClick={() => addCategory()}
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "flex-end",
                      marginRight: "63px",
                    }}
                  >
                    <p className="manda">
                      <b>
                        Add Category &nbsp; <i className="fas fa-smile fa-lg"></i>
                      </b>
                    </p>
                  </div>
                </div>

                <ReactQuill
                  onChange={(value) => {
                    setDescription(value);
                  }}
                  value={description}
                  modules={modules}
                  formats={formats}
                  placeholder="Enter Jobs Description"
                  required="required"
                />
                <br />
{/* 
                <ReactQuill
                  onChange={(value) => {
                    setDescription2(value);
                  }}
                  value={description2}
                  modules={modules}
                  formats={formats}
                  placeholder="Enter Description"
                  required="required"
                />
                <br />

                <ReactQuill
                  onChange={(value) => {
                    setDescription3(value);
                  }}
                  value={description3}
                  modules={modules}
                  formats={formats}
                  placeholder="Enter Description 2"
                  required="required"
                />
                <br />
                <br></br> */}

                <div className="form-group">
                  <label htmlFor="post-Images" className={styles.labelPostForm}>
                    Featured Image
                  </label>
                  <Input
                    id="file"
                    type="file"
                    name="image"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    onChange={(e) => onImageChange(e)}
                  />
                  <br></br>
                  <img
                    height="100px"
                    width="150px"
                    src={IMAGE_URL + article?.image}
                  />
                </div>
                <br></br>
                {/* <div className="form-group">
                  <label htmlFor="post-Images" className={styles.labelPostForm}>
                    Description Image
                  </label>
                  <Input
                    id="file"
                    type="file"
                    name="image"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    onChange={(e) => onDescriptionImageChange(e)}
                  />

                  <img
                    height="100px"
                    width="150px"
                    src={IMAGE_URL + article?.description_image}
                  />
                </div>

                <br /> */}
                <FormGroup>
                  {" "}
                  <div
                    onClick={() => addTag()}
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "flex-end",
                      marginRight: "63px",
                    }}
                  >
                    <p className="manda">
                      <b>
                        Add Tags &nbsp; <i className="fas fa-smile fa-lg"></i>
                      </b>
                    </p>
                  </div>
                  <Label for="City">Service Tags</Label>
                  <Select
                    allowSelectAll={true}
                    value={tags}
                    onChange={onTagsChange}
                    options={tagList}
                    isMulti={true}
                  // required="required"
                  />
                </FormGroup>

                <FormGroup>
                  <div
                    onClick={() => addFaq()}
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "flex-end",
                      marginRight: "63px",
                    }}
                  >
                    <p className="manda">
                      <b>
                        Add Faqs &nbsp; <i className="fas fa-smile fa-lg"></i>
                      </b>
                    </p>
                  </div>
                  <Label for="City">Faqs</Label>
                  <Select
                    allowSelectAll={true}
                    value={faqs}
                    onChange={onFaqsChange}
                    options={faqList}
                    isMulti={true}
                  // required="required"

                  />
                </FormGroup>

                <br />

                <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    Meta Title
                  </label>
                  <Input
                    name="title"
                    type="text"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    id="post-title"
                    required="required"
                    value={metaTitle}
                    onChange={(e) => onMetaTitleChange(e)}
                  />
                </div>
                <br />
                <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    Meta Description
                  </label>
                  <Input
                    name="title"
                    type="text"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    id="post-title"
                    value={metaDescription}
                    required="required"
                    onChange={(e) => onMetaDescriptionChange(e)}
                  />
                </div>

                {/* <label htmlFor="post-title" className={styles.labelPostForm}>
                  Meta Description
                </label>
                <ReactQuill
                  onChange={(value) => {
                    setMetaDescription(value);
                  }}
                  value={metaDescription}
                  modules={modules}
                  formats={formats}
                  placeholder="Enter Meta Description"
                  required="required"
                /> */}
                <br />
                {/* <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    Meta Keywords
                  </label>
                  <Input
                    name="title"
                    type="text"
                    id="post-title"
                    required="required"
                    value={keyword}
                    onChange={(e) => onKeywordChange(e)}
                  />
                </div> */}
                <br />

                <Input
                  type="submit"
                  name="submit"
                  className={`btn btn-danger ${styles.blogPostFormBtn}`}
                  value="Post Now"
                />
              </div>
              <br />
              <br />
            </div>
          </div>
          {/* <BlogForm handleChange={handleChange} /> */}
        </form>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        style={{ marginTop: "100px", marginLeft: "-28px" }}
      >
        <Modal.Header>
          <Modal.Title className=" ml-auto mr-auto pr-1">
            Create Blog Tags
          </Modal.Title>
        </Modal.Header>
        {/* <form> */}
        <form onSubmit={(e) => onAddTagSubmit(e)}>
          <div className={`container-fluid`}>
            <div className={styles.HeroiImgBlogForm}></div>
            <br />
            <div className="container">
              <div className={`form ${styles.blogPostForm}`}>
                <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    Name
                  </label>
                  <Input
                    name="title"
                    type="text"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    id="post-title"
                    required="required"
                    placeholder="audi"
                    onChange={(e) => onNameChange(e)}
                  />
                </div>
                <br />

                <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    Select Category
                  </label>
                  <br></br>
                  {/* <Label for="City">Property Type</Label> */}
                  <select
                    className="css-6j8wv5-Input"
                    onChange={(e) => onTagForChange(e)}
                    required
                  >
                    <option>Select Category</option>
                    <option value="blogs">Blogs</option>;
                    {/* <option value="jobs">Jobs</option>;
                    <option value="esate">Estate</option>; */}
                  </select>
                </div>
                <br />

                <Input
                  type="submit"
                  name="submit"
                  className={`btn btn-danger ${styles.blogPostFormBtn}`}
                  value="Submit"
                />
              </div>
              <br />
              <br />
            </div>
          </div>
          {/* <BlogForm handleChange={handleChange} /> */}
        </form>
      </Modal>


      <Modal
        show={show2}
        onHide={handleClose2}
        style={{ marginTop: "0px", marginLeft: "0px" }}
      >
        <Modal.Header>
          <Modal.Title className=" ml-auto mr-auto pr-1">
            Create Blog Faqs
          </Modal.Title>
        </Modal.Header>
        {/* <form> */}
        <form onSubmit={(e) => onSubmitFaq(e)}>
          <div className={`container-fluid`}>
            <div className={styles.HeroiImgBlogForm}>
              <div className={styles.paddingTopBottomBlogForm}>
                <h3 className={styles.HeroiImgTextBlogForm}>Add Faq</h3>
              </div>
            </div>
            <br />
            <div className="container">
              <div className={`form ${styles.blogPostForm}`}>
                <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    Question
                  </label>
                  <Input
                    name="title"
                    type="text"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    id="post-title"
                    required="required"
                    placeholder="i.e Driver’s Insurance is not mandatory ?"
                    onChange={(e) => onNameChangeFaq(e)}
                  />
                </div>
                <br />

                <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    Answer
                  </label>
                  <Input
                    name="title"
                    type="text"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    id="post-title"
                    required="required"
                    placeholder="i.e YES Driver’s Insurance is mandatory."
                    onChange={(e) => onTagForChangeFaq(e)}
                  />
                </div>
                <br />

                <Input
                  type="submit"
                  name="submit"
                  className={`btn btn-danger ${styles.blogPostFormBtn}`}
                  value="Submit"
                />
              </div>
              <br />
              <br />
            </div>
          </div>
          {/* <BlogForm handleChange={handleChange} /> */}
        </form>
        <span style={{ position: 'left' }} onClick={() => setShow2(false)}>close</span>

      </Modal>


      <Modal
        show={showCategory}
        onHide={handleCloseCategory}
        style={{ marginTop: "100px", marginLeft: "-28px" }}
      >
        <Modal.Header>
          <Modal.Title className=" ml-auto mr-auto pr-1">
            Create Category
          </Modal.Title>
        </Modal.Header>
        {/* <form> */}
        <div className="container">
          <form onSubmit={(e) => onAddCategorySubmit(e)}>
            <div className={`form ${styles.blogPostForm}`}>
              <div className="form-group">
                <label htmlFor="post-title" className={styles.labelPostForm}>
                  Name
                </label>
                <Input
                  name="title"
                  type="text"
                  //   class={`form-control ${styles.blogPostFormInput}`}
                  id="post-title"
                  required="required"
                  placeholder="Plots..."
                  onChange={(e) => onCategoryNameChange(e)}
                />
              </div>
              <br />
              <div className="form-group">
                <label htmlFor="post-title" className={styles.labelPostForm}>
                  Select Category
                </label>
                <br></br>
                {/* <Label for="City">Property Type</Label> */}
                <select
                  className="css-6j8wv5-Input"
                  onChange={(e) => onTagForCategoryChange(e)}
                  required
                >
                  <option>Select Category</option>
                  <option value="blogs">Blogs</option>;
                  {/* <option value="jobs">Jobs</option>;
                    <option value="esate">Estate</option>; */}
                </select>
              </div>
              <br />

              <Input
                type="submit"
                name="submit"
                className={`btn btn-danger ${styles.blogPostFormBtn}`}
                value="Create"
              />
            </div>
          </form>
          <br />
          <br />
        </div>
      </Modal>
    </>
  );
}

export default ArticleEdit;
